import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import { fetch_getQueryInfo } from '../actions/index';
import Cookies from 'universal-cookie';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import FontIcon from 'material-ui/FontIcon';
import {blue500, red500, greenA200} from 'material-ui/styles/colors';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';
import { checkProfilePic, encodeUrl, checkSexOption } from '../utility/tool';
import icon_user60 from "../imgs/icons8-user-60.png";

const fans_image_style = {
  verticalAlign:'top',
  display:'inline-block',
  width:'50px',
  height:'50px',
  marginRight:'6px',
  border:'1px solid gray',
  borderRadius:'2px',
  boxShadow: '0 1px 2px #666'
}

let cookies = new Cookies();

class kol_ranking_table extends Component {
  renderTables(data, allData, PqueryInfo){
    const scaleUp = 10000
    return (
      data.map((el,idx) => {
        let queryString = `/profile?fid=${el.fid}`
                        + `&tags=${PqueryInfo.Pchips}`
                        + `&skills=${PqueryInfo.Pskills}`
                        + `&jobs=${PqueryInfo.Pjobs}`
                        + `&fans_min=${PqueryInfo.PfansMin * scaleUp}`
                        + `&fans_max=${PqueryInfo.PfansMax * scaleUp}`
                        + `&period=${PqueryInfo.PdayQuery}`
                        + `&sex=${checkSexOption(PqueryInfo.Psex)}`
                        + `&source=${PqueryInfo.PsourceValue}`
                        + `&kol_name=${PqueryInfo.Pkol_name}`
                        + `&cat_op=${PqueryInfo.Pcat_op}`
                        + `&uuid=${el.uuid}`

        if(idx < this.props.displayNumber)
        {
          if(this.props.title == "領袖價值")
          {
            return (
              <TableRow key={el.fid} className="fansPostTableRow">
                <TableRowColumn className="tableCell picture cursorPointer" style={{width: '85%'}}>
                  <a href={encodeUrl(queryString)} className="tableCellLink">
                    <img src={checkProfilePic(el)} style={fans_image_style} onError={(e)=>{e.target.onerror = null; e.target.src = icon_user60}} />
                    <span className="leaderName">{el.name}</span>
                  </a>
                  <span className="rankNum">{idx + 1}</span>
                </TableRowColumn>
                <TableRowColumn className="tableCell totalNum" style={{whiteSpace:'normal',  width: '15%', textAlign:'center'}}>{Math.round(el.value)}</TableRowColumn>
              </TableRow>
            )
          }
          else
          {
            return (
              <TableRow key={el.fid} className="fansPostTableRow">
                <TableRowColumn className="tableCell picture cursorPointer" style={{width: '100%', wordWrap:'break-word'}}>
                  <a href={encodeUrl(queryString)} className="tableCellLink">
                    <img src={checkProfilePic(el)} style={fans_image_style} onError={(e)=>{e.target.onerror = null; e.target.src = icon_user60}} />
                    <span className="leaderName">{el.name}</span>
                  </a>
                  <span className="rankNum">{idx + 1}</span>
                </TableRowColumn>
              </TableRow>
            )
          }
        }
      })
    )
  }

  render(){

    if (this.props.data === undefined){
      return  <CircularProgress size={80} thickness={5} className="progressbar" color="#23a1ff" />; 
    }

    if(this.props.title === "領袖價值")
    {
      return (
       <div className={`kolTable ${this.props.bgSetting}`} style={{width:'220px', display:'inline-block', fontSize:'14px', margin:'5px'}}>
         <div className="rankingTable">
            <div className="kolTableTitle">{this.props.title}</div>
            <Table selectable={false} style={{fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"'}}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false} style={{border:"none"}}>
                  <TableRow style={{borderBottom:'1px solid #cdcdcd'}}>
                      <TableRowColumn className="tableHeaderColumn" style={{textAlign: 'left', width: '85%', backgroundColor:'#ffe8ca',borderRight:'1px solid #cdcdcd'}}>KOL排名</TableRowColumn>
                      <TableRowColumn className="tableHeaderColumn" style={{textAlign: 'left', width: '15%', backgroundColor:'#ffe8ca'}}>KD</TableRowColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                {this.renderTables(this.props.data, this.props.allData, this.props.PqueryInfo)}
                </TableBody>
            </Table>
          </div>
        </div>
      )
    }
    else
    {
      return (
       <div className={`kolTable ${this.props.bgSetting}`} style={{width:'205px', display:'inline-block', fontSize:'14px', margin:'5px'}}>
         <div className="rankingTable">
            <div className="kolTableTitle">{this.props.title}</div>
            <Table selectable={false} style={{fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"'}}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false} style={{border:"none"}}>
                  <TableRow style={{borderBottom:'1px solid #cdcdcd'}}>
                      <TableRowColumn className="tableHeaderColumn" style={{textAlign: 'left', width: '100%', backgroundColor:'#ffe8ca'}}>KOL排名</TableRowColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                {this.renderTables(this.props.data, this.props.allData, this.props.PqueryInfo)}
                </TableBody>
            </Table>
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps({queryInfo}) {
  return { queryInfo};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_getQueryInfo }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps )(kol_ranking_table);



// WEBPACK FOOTER //
// ./src/components/kol_ranking_table.js